import React from 'react';

import { useIntl } from 'react-intl';

import { getIcon } from '../../../../../common/ui/filters/filter-button/utils';
import PressableToggleFilter from '../../../../../common/ui/filters/pressable-toggle-filter';
import { useBooleanFilter } from '../../../../../controllers/filters/boolean-filter';
import { filter as verifiedFilter } from '../../../../../controllers/store/search/filters/verified';

import { i18n } from './messages';

const VerifiedFilter = (): React.JSX.Element | null => {
	const { formatMessage } = useIntl();

	const [state, { toggle }] = useBooleanFilter({
		filterId: verifiedFilter.id,
	});

	if (!state) {
		return null;
	}

	const { value, autoFocus } = state;

	const buttonIcon = getIcon({
		filterOrControlId: verifiedFilter.id,
		isSelected: value,
	});
	return (
		<PressableToggleFilter
			icon={buttonIcon}
			label={formatMessage(i18n.verified)}
			onClick={toggle}
			isSelected={value}
			autoFocus={autoFocus}
		/>
	);
};

export default VerifiedFilter;
